import React, {useEffect, useState} from "react";
import classes from "../JoinQuizPage/ClassResult.module.css";
import {LatexInline} from "../../components/Tiptap/latexParser";
import { ReactComponent as CORRECT_ICON } from "../../images/grade-question-correct-icon.svg";
import { Accordion } from '@base-ui/react/accordion';

export default function ViewLiveRespMH({premise, premiseIdx, data, shouldShowCorrect, correctAnswers, isShared, notShowAnimation=false}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const setBar = () => {
        let total = Object.values(data).reduce((result, item) => result + item, 0);
        Object.keys(data).forEach((option, index) => {
            let barWithPer = !total ? "0" : `${(data[option] / total) * 100}%`;
            let countBar = document.getElementById(`premise-${premiseIdx}-option-count-bar-${index}`);
            if (!!countBar) {
                countBar.style.width = barWithPer;
            }
        });
    }

    const resetBar = () => {
        Object.keys(data).forEach((option, index) => {
            let countBar = document.getElementById(`premise-${premiseIdx}-option-count-bar-${index}`);
            if (!!countBar) {
                countBar.style.width = "0";
            }
        });
    }


    useEffect(() => {
        if (isExpanded) {
            setBar();
        } else {
            resetBar();
        }
    }, [isExpanded, data]);

    return (
        <Accordion.Item
            value={premiseIdx}
            className={classes.premiseChartContainer}
            onOpenChange={open => setIsExpanded(open)}
        >
            <Accordion.Header style={{margin: 0, color: "inherit", fontSize: "inherit", fontWeight: "inherit"}}>
                <Accordion.Trigger className={classes.premiseChartContainerHeader}>
                     <span style={{
                         flex: 1,
                         minWidth: 0,
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                         textAlign: "start",
                     }}>
                        <LatexInline>{premise}</LatexInline>
                    </span>
                </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Panel className={classes.premiseChartContainerBody}>
                {Object.keys(data).map((option, i) =>
                    <div key={i} className={classes.countBarContainer}>
                        <div id={`premise-${premiseIdx}-option-count-bar-${i}`} className={classes.countBar} style={{transition: notShowAnimation ? "none" : undefined}}/>
                        <span id={`premise-option-text-${i}`} style={{position: "relative"}}>
                            <LatexInline>{option}</LatexInline>
                        </span>
                        <span style={{flex: 1}}/>

                        {!!shouldShowCorrect && correctAnswers[premiseIdx][1] === option &&
                            <span className={classes.correctBadge} ><CORRECT_ICON/></span>
                        }

                        {isShared &&
                            <span className={classes.countBadge}>{data[option]}</span>
                        }
                    </div>
                )}
            </Accordion.Panel>
        </Accordion.Item>
    );
}